import apiClient, { setBaseUrl, setToken } from './config'
import generationApi, { generateContent, pollGenerationStatus } from './generation'
import { uploadFile } from './upload'
import imageEnhanceApi, { enhanceImage } from './imageEnhance'
import oldPhotoRepairApi, { submitOldPhotoRepair, submitBlurryPhotoRepair, submitCartoonDigitalHuman, submitMangaDigitalHuman, submitOilPaintingDigitalHuman, submitIdPhotoGenerator, submitAiChangeClothes, submitFullWatermarkRemover, submitAiTextRemover, submitAiLogoRemover, submitAiPassersbyRemover, queryOldPhotoRepairResult, pollOldPhotoRepairResult } from './oldPhotoRepair'
import videoStyleConverterApi, { submitCartoonVideoStyleConverter, submitAnimeVideoStyleConverter, submitOilPaintingVideoStyleConverter, submitCyberpunkVideoStyleConverter, queryCapybaraVideoResult, pollCapybaraVideoResult } from './videoStyleConverter'
import authApi, { 
  login, 
  logout, 
  getCurrentUser, 
  updateProfile, 
  changePassword,
  requestPasswordReset,
  resetPassword,
  verifyEmail,
  resendVerification,
  isAuthenticated 
} from './auth'
import stripeApi, {
  createSubscription,
  createCreditsPurchase,
  getSubscription,
  cancelSubscription,
  getPaymentHistory
} from './stripe'
import { saveOrUpdateAIHistory, formatCreateDate, getAIHistory } from './aiHistory'
import watermarkRemoverApi, { processWatermarkWithFallback } from './watermarkRemover'

export {
  apiClient,
  setBaseUrl,
  setToken,
  generationApi,
  generateContent,
  pollGenerationStatus,
  uploadFile,
  imageEnhanceApi,
  enhanceImage,
  oldPhotoRepairApi,
  submitOldPhotoRepair,
  submitBlurryPhotoRepair,
  submitCartoonDigitalHuman,
  submitMangaDigitalHuman,
  submitOilPaintingDigitalHuman,
  submitIdPhotoGenerator,
  submitAiChangeClothes,
  submitFullWatermarkRemover,
  submitAiTextRemover,
  submitAiLogoRemover,
  submitAiPassersbyRemover,
  queryOldPhotoRepairResult,
  pollOldPhotoRepairResult,
  videoStyleConverterApi,
  submitCartoonVideoStyleConverter,
  submitAnimeVideoStyleConverter,
  submitOilPaintingVideoStyleConverter,
  submitCyberpunkVideoStyleConverter,
  queryCapybaraVideoResult,
  pollCapybaraVideoResult,
  authApi,
  login,
  logout,
  getCurrentUser,
  updateProfile,
  changePassword,
  requestPasswordReset,
  resetPassword,
  verifyEmail,
  resendVerification,
  isAuthenticated,
  stripeApi,
  createSubscription,
  createCreditsPurchase,
  getSubscription,
  cancelSubscription,
  getPaymentHistory,
  saveOrUpdateAIHistory,
  formatCreateDate,
  getAIHistory,
  watermarkRemoverApi,
  processWatermarkWithFallback
}

export default {
  client: apiClient,
  setBaseUrl: setBaseUrl,
  setToken: setToken,
  generation: generationApi,
  generateContent: generateContent,
  pollGenerationStatus: pollGenerationStatus,
  uploadFile: uploadFile,
  imageEnhance: imageEnhanceApi,
  enhanceImage: enhanceImage,
  oldPhotoRepair: oldPhotoRepairApi,
  submitOldPhotoRepair: submitOldPhotoRepair,
  submitBlurryPhotoRepair: submitBlurryPhotoRepair,
  submitCartoonDigitalHuman: submitCartoonDigitalHuman,
  submitMangaDigitalHuman: submitMangaDigitalHuman,
  submitOilPaintingDigitalHuman: submitOilPaintingDigitalHuman,
  submitIdPhotoGenerator: submitIdPhotoGenerator,
  submitAiChangeClothes: submitAiChangeClothes,
  submitFullWatermarkRemover: submitFullWatermarkRemover,
  submitAiTextRemover: submitAiTextRemover,
  submitAiLogoRemover: submitAiLogoRemover,
  submitAiPassersbyRemover: submitAiPassersbyRemover,
  queryOldPhotoRepairResult: queryOldPhotoRepairResult,
  pollOldPhotoRepairResult: pollOldPhotoRepairResult,
  videoStyleConverter: videoStyleConverterApi,
  submitCartoonVideoStyleConverter: submitCartoonVideoStyleConverter,
  submitAnimeVideoStyleConverter: submitAnimeVideoStyleConverter,
  submitOilPaintingVideoStyleConverter: submitOilPaintingVideoStyleConverter,
  submitCyberpunkVideoStyleConverter: submitCyberpunkVideoStyleConverter,
  queryCapybaraVideoResult: queryCapybaraVideoResult,
  pollCapybaraVideoResult: pollCapybaraVideoResult,
  auth: authApi,
  login: login,
  logout: logout,
  getCurrentUser: getCurrentUser,
  updateProfile: updateProfile,
  changePassword: changePassword,
  requestPasswordReset: requestPasswordReset,
  resetPassword: resetPassword,
  verifyEmail: verifyEmail,
  resendVerification: resendVerification,
  isAuthenticated: isAuthenticated,
  stripe: stripeApi,
  createSubscription: createSubscription,
  createCreditsPurchase: createCreditsPurchase,
  getSubscription: getSubscription,
  cancelSubscription: cancelSubscription,
  getPaymentHistory: getPaymentHistory,
  saveOrUpdateAIHistory,
  formatCreateDate,
  getAIHistory,
  watermarkRemover: watermarkRemoverApi,
  processWatermarkWithFallback: processWatermarkWithFallback
}
